const config = {
  baseURL: 'https://eduapi.huashuyunai.com/index.php?s=/api/',
  wss: 'wss://az-chat.k8s.bitheroai.com:443/',
  chatBaseUrl: 'https://az-chat.k8s.bitheroai.com/',
  captchaId: "00bc2d4e733318ab93d0bc5abdf0803c"
}

module.exports = config
